import './LoadingSkeleton.css';
export default {
    "loadingContainer": "LoadingSkeleton_loadingContainer__128fx",
    "loadingSkeletonContainer": "LoadingSkeleton_loadingSkeletonContainer__128fx",
    "slideRight": "LoadingSkeleton_slideRight__128fx"
};
